import { Button, Card } from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import { AddPopup_addpopup } from "@saleor/checkoutAdd/types/AddPopup";
import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import CardTitle from "@saleor/components/CardTitle";
import { ConfirmButtonTransitionState } from "@saleor/components/ConfirmButton";
import Container from "@saleor/components/Container";
import ControlledCheckbox from "@saleor/components/ControlledCheckbox";
import Form from "@saleor/components/Form";
import FormSpacer from "@saleor/components/FormSpacer";
import Grid from "@saleor/components/Grid";
import PageHeader from "@saleor/components/PageHeader";
import S3TextField from "@saleor/components/S3TextField";
import SaveButtonBar from "@saleor/components/SaveButtonBar";
import { Tab, TabContainer } from "@saleor/components/Tab";
import { commonMessages, sectionNames } from "@saleor/intl";
import { maybe } from "@saleor/misc";
import { ListProps2, ReorderAction, TabListActions } from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import CheckoutAddVariants from "../CheckoutAddVariants";
export interface CheckoutAddDetailsProps
  extends Pick<ListProps2, Exclude<keyof ListProps2, "onRowClick">>,
    TabListActions<"variantListToolbar"> {
  checkoutAdd: AddPopup_addpopup;
  onSubmit: (data: CheckoutAddFormData) => void;
  onBack: () => void;
  disabled: boolean;
  saveButtonBarState: ConfirmButtonTransitionState;
  activeTab: CheckoutAddDetailsPageTab;
  defaultCreate: () => void;
  onTabClick: (index: CheckoutAddDetailsPageTab) => void;
  onVariantAssign: () => void;
  onVariantUnassign: (id: string) => void;
  onVariantClick: (productId: string, variantId: string) => () => void;
  onVariantReorder: ReorderAction;
}

export interface VariantsData {
  variantId: string;
  sortOrder: any;
}

export interface CheckoutAddFormData {
  name: string;
  addPcImage: string;
  addMbImage: string;
  addLink: string;
  enable: boolean;
  addpopupVariants?: VariantsData[];
}

export enum CheckoutAddDetailsPageTab {
  variants = "variants"
}

export function saleDetailsPageTab(tab: string): CheckoutAddDetailsPageTab {
  return tab === CheckoutAddDetailsPageTab.variants
    ? CheckoutAddDetailsPageTab.variants
    : CheckoutAddDetailsPageTab.variants;
}

const VariantsTab = Tab(CheckoutAddDetailsPageTab.variants);

const CheckoutAddDetails: React.FC<CheckoutAddDetailsProps> = ({
  checkoutAdd,
  onSubmit,
  disabled,
  onBack,
  activeTab,
  onTabClick,
  defaultCreate,
  saveButtonBarState,
  // onNextPage,
  // onPreviousPage,
  onVariantAssign,
  onVariantUnassign,
  onVariantReorder,
  onVariantClick,
  isChecked,
  selected,
  toggle,
  toggleAll,
  variantListToolbar,
  pageInfo
}) => {
  const initialForm: CheckoutAddFormData = {
    name: maybe(() => checkoutAdd.name, ""),
    addLink: maybe(() => checkoutAdd.addLink, ""),

    enable: maybe(() => checkoutAdd.enable, false),
    addPcImage: maybe(() => checkoutAdd.addPcImage, ""),
    addMbImage: maybe(() => checkoutAdd.addMbImage, ""),
    addpopupVariants: maybe(
      () =>
        checkoutAdd.addpopupVariants.map(variant => ({
          variantId: variant.variant.id,
          sortOrder: variant.sortOrder || null
        })),
      null
    )
  };
  const intl = useIntl();
  return (
    <>
      <Form initial={initialForm} onSubmit={onSubmit}>
        {({ change, data, hasChanged, setNameValue, submit }) => (
          <Container>
            <AppHeader onBack={onBack}>
              <FormattedMessage {...sectionNames.configuration} />
            </AppHeader>
            <PageHeader title={"Checkout Add"} />
            <Grid>
              {checkoutAdd ? (
                <>
                  <Card>
                    <CardTitle
                      title={intl.formatMessage(
                        commonMessages.generalInformations
                      )}
                    />
                    <CardContent>
                      <TextField
                        disabled={disabled}
                        label={intl.formatMessage({
                          defaultMessage: "Name",
                          description: "Name"
                        })}
                        name={"name" as keyof CheckoutAddFormData}
                        fullWidth
                        value={data.name}
                        onChange={change}
                      />
                      <FormSpacer />
                      <S3TextField
                        disabled={disabled}
                        label={intl.formatMessage({
                          defaultMessage: "Ad Pc Image",
                          description: "Ad Pc Image"
                        })}
                        name={"addPcImage" as keyof CheckoutAddFormData}
                        value={data.addPcImage}
                        onChange={change}
                        setNameValue={setNameValue}
                      />
                      <FormSpacer />
                      <S3TextField
                        disabled={disabled}
                        label={intl.formatMessage({
                          defaultMessage: "Ad Mobile Image",
                          description: "Ad Mobile Image"
                        })}
                        name={"addMbImage" as keyof CheckoutAddFormData}
                        value={data.addMbImage}
                        onChange={change}
                        setNameValue={setNameValue}
                      />
                      <FormSpacer />
                      <TextField
                        disabled={disabled}
                        label={intl.formatMessage({
                          defaultMessage: "Ad Link",
                          description: "Ad Link"
                        })}
                        name={"addLink" as keyof CheckoutAddFormData}
                        fullWidth
                        value={data.addLink}
                        onChange={change}
                      />
                      <FormSpacer />

                      <ControlledCheckbox
                        name={"enable" as keyof CheckoutAddFormData}
                        label={intl.formatMessage({
                          defaultMessage: "Enable",
                          description: "enable"
                        })}
                        checked={data.enable}
                        onChange={change}
                        disabled={disabled}
                      />
                    </CardContent>
                  </Card>
                  <CardSpacer />
                  <TabContainer>
                    <VariantsTab
                      isActive={
                        activeTab === CheckoutAddDetailsPageTab.variants
                      }
                      changeTab={onTabClick}
                    >
                      {/* {intl.formatMessage(
                                        {
                                            defaultMessage: "SKU({quantity})",
                                            description: "number of skus",
                                            id: "saleDetailsPageVariantsQuantity"
                                        },
                                        {
                                            quantity: maybe(
                                            () => specialOffer.redemptionVariants.totalCount.toString(),
                                            "…"
                                            )
                                        }
                                        )} */}
                      {intl.formatMessage({
                        defaultMessage: "SKU",
                        description: "number of skus",
                        id: "saleDetailsPageVariantsQuantity"
                      })}
                    </VariantsTab>
                  </TabContainer>
                  <CardSpacer />
                  {activeTab === CheckoutAddDetailsPageTab.variants ? (
                    <CheckoutAddVariants
                      onVariantReorder={onVariantReorder}
                      disabled={disabled}
                      onNextPage={null}
                      onPreviousPage={null}
                      onVariantAssign={onVariantAssign}
                      onVariantUnassign={onVariantUnassign}
                      onRowClick={onVariantClick}
                      pageInfo={pageInfo}
                      checkoutAdd={checkoutAdd}
                      isChecked={isChecked}
                      selected={selected}
                      toggle={toggle}
                      toggleAll={toggleAll}
                      toolbar={variantListToolbar}
                      onChange={change}
                      data={data}
                    />
                  ) : (
                    <CheckoutAddVariants
                      onVariantReorder={onVariantReorder}
                      disabled={disabled}
                      onNextPage={null}
                      onPreviousPage={null}
                      onVariantAssign={onVariantAssign}
                      onVariantUnassign={onVariantUnassign}
                      onRowClick={onVariantClick}
                      pageInfo={pageInfo}
                      checkoutAdd={checkoutAdd}
                      isChecked={isChecked}
                      selected={selected}
                      toggle={toggle}
                      toggleAll={toggleAll}
                      toolbar={variantListToolbar}
                      onChange={change}
                      data={data}
                    />
                  )}
                </>
              ) : (
                <Card>
                  <CardContent>
                    <Button
                      color="primary"
                      onClick={defaultCreate}
                      disabled={disabled}
                    >
                      <FormattedMessage
                        defaultMessage="Create Default"
                        description="button"
                      />
                    </Button>

                    <CardSpacer />
                    <p style={{ color: "#999", marginLeft: "20px" }}>
                      {
                        "New Checkout Add has not been set, please initialize first"
                      }
                    </p>
                  </CardContent>
                </Card>
              )}
            </Grid>
            <SaveButtonBar
              disabled={disabled || !hasChanged}
              state={saveButtonBarState}
              onCancel={onBack}
              onSave={submit}
              onDelete={undefined}
            />
          </Container>
        )}
      </Form>
    </>
  );
};
export default CheckoutAddDetails;
